import TreeNode from "../../../structures/TreeNode";
function random(options) {
  // If options is a function, call it to get the actual options
  const actualOptions = typeof options === "function" ? options() : options;

  if (!Array.isArray(actualOptions)) {
    throw new Error(
      "Random expects an array or a function that returns an array",
    );
  }

  if (actualOptions.length === 0) {
    throw new Error("Cannot select from empty array");
  }

  const randomIndex = Math.floor(Math.random() * actualOptions.length);
  return actualOptions[randomIndex];
}

/**
  Example
  
 *  Node
    const node1 = new TreeNode(0, false, -790, 590, "¿En qué afore estoy?", 2);

 *  Game node
    const node2 = new TreeNode(0, false, -790, 590); //juego 0

 *  Set Descendants
    node1.descendants = [
      { node: node1_2, hint: "Preguntaré en RH de mi empresa" },
      { node: node1_3, hint: "Revisaré en internet" },
    ];

 *  Set Game
    node2.game = 0;
 */

const node1 = new TreeNode(
  0,
  false,
  -1052,
  772,
  "Perdí mi trabajo, ¿existirá algún progama de ayuda para salir del apuro mientras encuentro otro?",
  0,
  "neutral",
);

node1.quotes = ["“El estrés de no ser autosuficiente es lo peor”"];

const node1_2 = new TreeNode(
  2,
  false,
  -1052,
  772,
  "Un amigo me dijo que se puede hacer un retiro de la Afore, pero no sé en cuál estoy. Creo que alguna vez me puse en contacto con Profuturo.",
  1,
);

node1_2.quotes = [
  "“Con esto podré darles algo a mis hijos en Navidad”",
  "“Me enteré por un amigo que podía hacer retiros en mi Afore si es que lo necesitaba”",
  "“Cuando perdí mi empleo, lo único que me preocupaba era la inscripción de mi hija a la escuela”",
];

const node1_3 = new TreeNode(
  2,
  false,
  -1405,
  980,
  "Encontré que puedo hacer un retiro de mi Afore. No recuerdo en cuál estoy, pero creo que alguna vez me puse en contacto con Profuturo.",
  /*1*/ 0,
);

const node2_2 = new TreeNode(
  2,
  false,
  -1405,
  980,
  "Estuve en lo correcto, si estoy con Profuturo. Buscaré como contactarlos.",
  0,
);

const node5_1 = new TreeNode(2, false, -2687, 1100, "Llamando.", 0);

const node5_1_1 = new TreeNode(
  1,
  false,
  -2687,
  1100,
  "Hola, está marcando a Profuturo, ¿en qué le puedo apoyar?",
  0,
);

node5_1_1.dialogAnchor = { x: 5 };

const node5_1_2 = new TreeNode(
  0,
  false,
  -2687,
  1100,
  "Hola, me gustaría hacer mi retiro por desempleo. ¿me podría indicar cuáles son los requisitos?",
  0,
);

const node5_1_3 = new TreeNode(
  1,
  false,
  -2687,
  1100,
  "Claro, ¿me podría compartir su CURP o NSS?",
  0,
);

node5_1_3.dialogAnchor = { x: 5 };

const node5_aun_no_cliente = new TreeNode(
  1,
  false,
  -2687,
  1100,
  "Checando su información en el sistema, me aparece que aún no es cliente Profuturo. Primero tendremos que hacer su traspaso por nuestra app Profuturo Móvil o por Afore Móvil.",
  0,
  "frustrated",
);
node5_aun_no_cliente.dialogAnchor = { x: 5, y: 5 };

const node5_aun_no_cliente_1 = new TreeNode(
  1,
  false,
  -2687,
  1100,
  `Una vez siendo cliente Profuturo, lo invitamos a acudir a sucursal para la creación de su expediente de identificación y solicitar tu trámite de retiro por desempleo por la App Profuturo Móvil`,
  0,
);

const node5_aun_no_cliente_1_1 = new TreeNode(
  1,
  false,
  -2687,
  1100,
  "sino también lo puedes realizar a través de la misma sucursal o por la Aplicación de Afore Móvil o Afore Web.",
  0,
);

node5_aun_no_cliente_1.dialogAnchor = { x: 5, y: -2.5 };

const node5_aun_no_cliente_2 = new TreeNode(
  0,
  false,
  -2687,
  1100,
  "¿Todo eso tengo que hacer?¿No hay una forma más rápida de hacerlo?",
  0,
);

const node5_aun_no_cliente_3 = new TreeNode(
  1,
  false,
  -2687,
  1100,
  "Temo que no, pero estamos aquí para apoyarlo en lo que necesite.",
  0,
);

node5_aun_no_cliente_3.dialogAnchor = { x: 5.8, y: 2.8 };

const node5_aun_no_cliente_4 = new TreeNode(
  0,
  false,
  -2687,
  1100,
  "Muchas gracias, empezaré con el trámite de cambio de Afore.",
  0,
);

const node5_aun_no_cliente_5 = new TreeNode(
  0,
  false,
  -2687,
  1100,
  "Como puede ser posible que el trámite para poder sacar dinero de mi cuenta por desempleo sea tan complicado. Ni modo, comenzaré con mi traspaso.",
  0,
);

const node5_aun_no_cliente_5_1 = new TreeNode(
  1,
  false,
  -3215,
  1394,
  "Hola. bienvenido a Profuturo, ¿tiene agendada una cita?",
  25,
);

const node5_aun_no_cliente_5_2 = new TreeNode(
  0,
  false,
  -3215,
  1394,
  "No, pero vengo a hacer mi retiro por desempleo.",
  0,
);

const node5_aun_no_cliente_5_3 = new TreeNode(
  1,
  false,
  -3215,
  1394,
  "Muy bien, ¿tiene todos los documentos?",
  0,
);

const node5_aun_no_cliente_5_4 = new TreeNode(
  1,
  false,
  -3215,
  1394,
  "Juego (Conformación de expediente)",
  0,
);
node5_aun_no_cliente_5_4.game = 24;

const node5_aun_no_cliente_5_4_1 = new TreeNode(
  0,
  false,
  -3215,
  1394,
  "Sí, los traigo todos.",
  0,
);

const node5_aun_no_cliente_5_5 = new TreeNode(
  1,
  false,
  -3215,
  1394,
  "Perfecto, por favor, tendrás que esperar a que uno de los asistentes se desocupe, ya que hay clientes con cita que tienen un horario asignado de atención.",
  0,
);
node5_aun_no_cliente_5_5.dialogAnchor = { y: 2 };

const node7 = new TreeNode(
  2,
  false,
  -3215,
  1394,
  "7 días después.",
  7 * 24,
  "angry",
);

const node7_1 = new TreeNode(
  1,
  false,
  -3215,
  1394,
  "Hola, bienvenido a Profuturo, ¿tiene agendada una cita?",
  0,
  "angry",
);
node7_1.quotes = [
  "“Me urge el dinero y al final se tardan años, no tienen nada de consideración con sus clientes, solo nos ponen trabas y trabas para sacar NUESTRO dinero”",
];
node7_1.dialogAnchor = { y: 2 };

const node7_1_1 = new TreeNode(
  0,
  false,
  -3215,
  1394,
  "Sí, agendé cita para hacer mi expediente y luego mi retiro por desempleo.",
  0,
);

const node7_1_2 = new TreeNode(
  1,
  false,
  -3215,
  1394,
  "Perfecto, aquí la tengo registrada, ¿tiene todos los documentos para el trámite de expediente?",
  0,
  "frustrated",
);

node7_1_2.dialogAnchor = { y: 2 };

const node7_1_2_a = new TreeNode(
  1,
  false,
  -3215,
  1394,
  "Juego (Conformación de expediente)",
  0,
);
node7_1_2_a.game = 24;

const node7_1_3 = new TreeNode(
  0,
  false,
  -3215,
  1394,
  "Sí, los traigo todos.",
  0,
);

const node7_1_4 = new TreeNode(
  1,
  false,
  -3215,
  1394,
  "Perfecto, por favor, pase con el asistente para ser atendido.",
  0,
);

node7_1_4.dialogAnchor = { y: 2 };

const node7_1_5 = new TreeNode(
  1,
  false,
  -3700,
  1420,
  "Buen día. Entiendo que viene a hacer su expediente de identificación y a hacer un retiro por desempleo, ¿me puede compartir sus documentos, por favor?",
  0,
);

const node7_1_6 = new TreeNode(0, false, -3700, 1420, "Aquí están.", 0);

const node7_1_7 = new TreeNode(
  1,
  false,
  -3700,
  1420,
  "Vamos a comenzar con la captura de su información.",
  0,
  "frustrated",
);

const node8 = new TreeNode(2, false, -3700, 1420, "Juego Datos biometricos");
node8.game = 3;

const node8_2_4_3 = new TreeNode(
  1,
  false,
  -3700,
  1420,
  "Listo, ya quedó la solicitud para el trámite de expediente de identificación. Este queda listo en aproximadamente 5 días hábiles, por favor revise su correo para que una vez aprobado pueda realizar su retiro por desempleo por medio de la App Profuturo Móvil o acuda nuevamente a la sucursal.",
  1,
);

const node8_2_4_4 = new TreeNode(
  0,
  false,
  -3700,
  1420,
  "Perfecto, muchas gracias, estaré pendiente.",
  0,
);

const node8_2_4_5 = new TreeNode(
  2,
  false,
  -3150,
  1358,
  "Después de 5 días.",
  5 * 24,
);

const node8_2_4_6 = new TreeNode(
  0,
  false,
  -3150,
  1358,
  "Listo, ya me llegó la notificación de aceptación de expediente. Ya tengo agendada mi cita para el día de mañana para poder generar mi retiro por desempleo.",
  0,
);

const node8_4 = new TreeNode(
  0,
  false,
  -3215,
  1394,
  "Hola, recibí la confirmación exitosa de la generación de mi expediente y quiero tramitar mi retiro por desempleo, por favor.",
  24,
);

const node8_4_1 = new TreeNode(
  1,
  false,
  -3215,
  1394,
  "Muy bien, ¿tiene todos los documentos?",
  0,
);
node8_4_1.dialogAnchor = { y: 2 };

const node8_4_1_1 = new TreeNode(
  0,
  false,
  -3215,
  1394,
  "Sí, los traigo todos.",
  0,
);

const node8_4_1_2 = new TreeNode(
  1,
  false,
  -3215,
  1394,
  "Perfecto, por favor, pase con el asistente para ser atendido.",
  0,
);

node8_4_1_2.dialogAnchor = { y: 2 };

const node4 = new TreeNode(
  0,
  false,
  -1405,
  980,
  "En su página vi el teléfono y dónde están las sucursales, pero también tienen una app.",
  1,
);

const node7_2 = new TreeNode(
  1,
  false,
  -3215,
  1394,
  "Hola, bienvenido a Profuturo, ¿tiene agendada una cita?",
  /*24*/ 0,
  "frustrated",
);

node7_2.dialogAnchor = { y: 2 };

node7_2.quotes = [
  "“Me urge el dinero y al final se tardan años, no tienen nada de consideración con sus clientes, solo nos ponen trabas y trabas para sacar NUESTRO dinero”",
];

const node7_2_2 = new TreeNode(
  0,
  false,
  -3215,
  1394,
  "No, pero vengo a hacer mi retiro por desempleo.",
  0,
);

const node7_2_2_1 = new TreeNode(
  1,
  false,
  -3215,
  1394,
  "Muy bien, ¿tiene todos los documentos?",
  0,
);

const node7_2_2_2 = new TreeNode(
  0,
  false,
  -3215,
  1394,
  "Sí, los traigo todos.",
  0,
);

const node7_2_5 = new TreeNode(
  1,
  false,
  -3215,
  1394,
  "Perfecto, por favor, tendrás que esperar a que uno de los asistentes se desocupe, ya que hay clientes con cita que tienen un horario asignado de atención.",
  0,
);
node7_2_5.dialogAnchor = { y: 2 };

const node7_2_6 = new TreeNode(
  0,
  false,
  -3215,
  1394,
  "De acuerdo, muchas gracias.",
  0,
);

const node7_2_6_1 = new TreeNode(
  2,
  false,
  -3215,
  1394,
  "Una hora después.",
  1,
  "frustrated",
);

const node4_1 = new TreeNode(
  0,
  false,
  -2177,
  1263,
  "Veo que sólo hay citas para dentro de dos semanas, no sé qué hacer.",
  /*1*/ 0,
);

node4_1.quotes = ["“Échame la mano, no tengo ni para comer”"];

const node4_1_7_dias_despues = new TreeNode(
  2,
  false,
  -2177,
  1263,
  "15 días después.",
  /*15 * 24*/ 0,
);

const node6_2_1 = new TreeNode(
  0,
  false,
  -3215,
  1394,
  "Hola, tengo una cita para hacer el trámite de retiro por desempleo.",
  0,
  "angry",
);
node6_2_1.dialogAnchor = { y: 2 };

const node6_2_1a_1 = new TreeNode(
  1,
  false,
  -3215,
  1394,
  "Perfecto, por favor, pase con el asistente para ser atendido.",
  0,
);
node6_2_1a_1.dialogAnchor = { y: 2 };

const node8_4_12 = new TreeNode(
  1,
  false,
  -3700,
  1420,
  "Buen día. Entiendo que viene a un retiro por desempleo, ¿me puede compartir sus documentos, por favor?",
  0,
);

const node8_4_13 = new TreeNode(0, false, -3700, 1420, "Aquí están.", 0);

const node8_4_14 = new TreeNode(
  1,
  false,
  -3700,
  1420,
  "Llenaremos la solicitud en línea.",
  0,
);

const node8_5 = new TreeNode(2, false, -3700, 1420, "Juego 3 (Proximamente)"); //juego 2
node8_5.game = 27;

const node8_5_1 = new TreeNode(
  1,
  false,
  -3700,
  1420,
  "Al parecer, hay intermitencias en los sistemas y no podremos continuar con el trámite.",
  1,
  "angry",
);

node8_5_1.quotes = [
  "“Se les olvida que es dinero del ahorrador, su aplicación para celular NUNCA funcionó, su personal siempre le echa la culpa al IMSS, y mientras uno apenas vive, el dinero no es para la parranda, ¡es para SOBREVIVIR!”",
];

const node8_5_1_1 = new TreeNode(
  0,
  false,
  -3700,
  1420,
  "¿Cree que se estabilicen pronto?",
  0,
);

const node8_5_1_2 = new TreeNode(
  1,
  false,
  -3700,
  1420,
  "No lo sabemos, pero si está de acuerdo, le agendamos un espacio mañana para continuar con el trámite.",
  0,
);

const node8_5_1_3 = new TreeNode(0, false, -3700, 1420, "Está bien.", 0);

const node8_6 = new TreeNode(2, false, -3085, 1324, "Al día siguiente", 24);

const node8_6_1 = new TreeNode(
  0,
  false,
  -3215,
  1394,
  "Hola, ya había empezado a hacer mi retiro por desempleo pero hubo intermitencia en el sistema, vengo a continuar con el trámite.",
  /*24*/ 0,
);

node8_6_1.dialogAnchor = { y: 2 };

const node8_6_2 = new TreeNode(
  1,
  false,
  -3215,
  1394,
  "Perfecto. Por favor, pase con el asistente para ser atendido.",
  0,
);

node8_6_2.dialogAnchor = { y: 2 };

const node8_5_4 = new TreeNode(
  1,
  false,
  -3700,
  1420,
  "Todos tus documentos están en orden, llenemos la solicitud.",
  /*2*/ 0,
  "neutral",
);

node8_5_4.quotes = [
  "“Hace unos años había hecho el trámite de retiro y fue muy tardado, que bueno que mejoraron su atención y sus procesos, hacen que sea más fácil la situación que uno vive”",
];

const node8_7 = new TreeNode(
  2,
  false,
  -3700,
  1420,
  "Juego 4 (Proximamente)",
  0,
  "neutral",
); //juego 3
node8_7.game = 6;

const node_descargar_app = new TreeNode(
  2,
  false,
  -2177,
  1263,
  "Descarga la App Profuturo Móvil",
  /*1*/ 0,
);

const node_descargar_app_1 = new TreeNode(
  0,
  false,
  -2177,
  1263,
  "Ya soy cliente, pero tengo que registrar mi usuario.",
  0,
);

const node_descargar_app_1_error = new TreeNode(
  2,
  false,
  -2177,
  1263,
  "Se produjo un error en tu inicio de sesión, inténtalo más tarde.",
  0,
  "frustrated",
);

const node_descargar_app_1_reintentar = new TreeNode(
  0,
  false,
  -2177,
  1263,
  "Intentaré ingresar otra vez.",
  0,
);

const node_descargar_app_1_success = new TreeNode(
  0,
  false,
  -2177,
  1263,
  "¡Perfecto, ya logré entrar!",
  0,
);

const node_descargar_app_registrar_expediente = new TreeNode(
  2,
  false,
  -2177,
  1263,
  "Ya eres cliente Profuturo, pero no tienes tu Expediente completo, antes de hacer el trámite de Retiro, tenemos que completar tu Expediente Móvil",
  /*1*/ 0,
  "frustrated",
);
node_descargar_app_registrar_expediente.game = 18;

const node_descargar_app_expediente_completo = new TreeNode(
  0,
  false,
  -2177,
  1263,
  "Ok, ya tengo mi expediente móvil, continuemos navegando.",
  /*120*/ 0,
);

const node_descargar_app_expediente_completo_opcion_retiro = new TreeNode(
  2,
  false,
  -2177,
  1263,
  `Aquí en trámites encontré la opción de "Retiro por Desempleo".`,
  0,
);

const node_descargar_app_expediente_completo_acudir_a_sucursal = new TreeNode(
  100,
  false,
  -2177,
  1263,
  "ACUDIR_A_SUCURSAL",
  /*1*/ 0,
  "angry",
);

const node_descargar_app_expediente_completo_acudir_a_sucursal_1 = new TreeNode(
  2,
  false,
  -2177,
  1263,
  "Después de 15 días.",
  15 * 24,
);

const node_descargar_app_expediente_completo_IMSS_no_disponible = new TreeNode(
  100,
  false,
  -2177,
  1263,
  "IMSS_NO_DISPONIBLE",
  0,
  "frustrated",
);

const node_descargar_app_expediente_completo_IMSS_no_disponible_1 =
  new TreeNode(
    0,
    false,
    -2177,
    1263,
    "Tendré que intentarlo mañana, esperando tener suerte para continuar con mi trámite.",
    0,
    "frustrated",
  );

const node_descargar_app_expediente_completo_IMSS_no_disponible_2 =
  new TreeNode(2, false, -2177, 1263, "Pasa 1 día", 24, "frustrated");

const node_descargar_app_expediente_completo_esperar_para_retirar =
  new TreeNode(
    100,
    false,
    -2177,
    1263,
    "ESPERAR_PARA_VOLVER_A_RETIRAR",
    0,
    "angry",
  );

const node_descargar_app_expediente_completo_esperar_para_retirar_1 =
  new TreeNode(
    0,
    false,
    -2177,
    1263,
    "Ni modo, tendré que buscar en otro lugar",
    0,
  );

const node_descargar_app_expediente_completo_continuar_proceso = new TreeNode(
  100,
  false,
  -2177,
  1263,
  "CONTINUAR_CON_EL_PROCESO",
  0,
  "smile",
);

const node_descargar_app_expediente_completo_continuar_proceso_1 = new TreeNode(
  0,
  false,
  -2177,
  1263,
  "Oh, no sabía que esta ayuda provenia de lo que había ahorrado en mi Afore y que se me descontarían semanas.",
  0,
  "neutral",
);

const node_descargar_app_expediente_completo_continuar_proceso_2 = new TreeNode(
  0,
  false,
  -2177,
  1263,
  "Bueno, no importa, lo necesito en este momento, ya más adelante lo vuelvo a recuperar.",
  0,
  "neutral",
);

const node_descargar_app_expediente_completo_continuar_proceso_3 = new TreeNode(
  2,
  false,
  -2177,
  1263,
  "Conoce los impactos a la cuenta y tiempo de cotización.",
  /*1*/ 0,
  "neutral",
);

const node_descargar_app_expediente_completo_continuar_proceso_4 = new TreeNode(
  0,
  false,
  -2177,
  1263,
  "Estoy listo para comenzar con mi retiro por desempleo.",
  0,
);

const node_descargar_app_expediente_completo_continuar_proceso_5 = new TreeNode(
  0,
  false,
  -2177,
  1263,
  "Necesito recabar los siguientes documentos para continuar con el trámite",
  /*3*/ 0,
  "neutral",
);

node_descargar_app_expediente_completo_continuar_proceso_5.game = 28;

const node_validar_datos_error_48_dias_transcurridos = new TreeNode(
  100,
  false,
  -2177,
  1263,
  "VALIDAR_DATOS_ERROR_2",
  0,
  "angry",
);

const node_validar_datos_error_48_dias_transcurridos_1 = new TreeNode(
  0,
  false,
  -2177,
  1263,
  "Tendré que esperar unos días más, lo volveré a intentar después.",
  0,
);

const node_validar_datos_error_48_dias_transcurridos_2 = new TreeNode(
  2,
  false,
  -2177,
  1263,
  "Pasan 46 días",
  46 * 24,
);

const node_validar_datos_error_actualmente_trabajando = new TreeNode(
  100,
  false,
  -2177,
  1263,
  "VALIDAR_DATOS_ERROR_1",
  0,
  "angry",
);

const node_validar_datos_error_actualmente_trabajando_1 = new TreeNode(
  0,
  false,
  -2177,
  1263,
  "No puede ser, tengo que ir a ver en la empresa donde trabajaba porque no me han dado de baja.",
  /*24 * 6 + 3*/ 0,
  "frustrated",
);

const node_validar_datos_error_actualmente_trabajando_2 = new TreeNode(
  0,
  false,
  -2177,
  1263,
  "Tendré que intentarlo otro día.",
  /*24 * 6 + 3*/ 0,
);

const node_validar_datos_continuar_proceso = new TreeNode(
  100,
  false,
  -2177,
  1263,
  "VALIDAR_DATOS_CONTINUAR_PROCESO",
  0,
  "smile",
);

const node_validar_datos_continuar_proceso_1_1 = new TreeNode(
  0,
  false,
  -2177,
  1263,
  "Tengo 3 años cotizando y sólo me dan 30 días de salario, bueno no está mal, lo necesito.",
  0,
);

const node_validar_datos_continuar_proceso_1_2 = new TreeNode(
  0,
  false,
  -2177,
  1263,
  "Tengo más de 5 años cotizando y me ofrecen una cantidad comparable de tres meses de mi sueldo. \nLo acepto.",
  0,
);

const node_validar_datos_continuar_proceso_2 = new TreeNode(
  2,
  false,
  -2177,
  1263,
  "Debo seleccionar la cuenta donde se me depositará el dinero.",
  /*1*/ 0,
);

node_validar_datos_continuar_proceso_2.game = 20;

const node_validar_datos_continuar_proceso_2_end = new TreeNode(
  0,
  false,
  -2177,
  1263,
  "Se ha generado tu solicitud de retiro por desempleo exitosamente",
  0,
);

const node8_7_5 = new TreeNode(
  1,
  false,
  -3700,
  1420,
  "El diagnóstico fue aceptado.",
  0,
  "neutral",
);

node8_7_5.quotes = [
  "“Me explicaron las consecuencias de hacer el retiro, está bien que nos digan para estar informados y poder hacer algo después”",
];

const node8_7_5_1 = new TreeNode(
  1,
  false,
  -3700,
  1420,
  "La solicitud no tuvo problemas. Ahora hay que esperar 5 días hábiles. Se confirmará con un SMS para el aviso del depósito.",
  0,
);

const node8_7_5_2 = new TreeNode(
  0,
  false,
  -3700,
  1420,
  "Muchas gracias, estaré pendiente.",
  0,
);

node8_7_5_2.dialogAnchor = { y: 2 };

node8_7_5_2.quotes = [
  "“Me debieron depositar a inicios del mes y sigo esperando el deposito, por eso es apoyo de desempleo porque no tengo un ingreso y requiero de dinero para saldar deudas y gasto corriente”",
  "“Demasiado complejos los requisitos y además el trámite deberia ser único y no en abonos”",
];

const node8_7_6 = new TreeNode(
  0,
  false,
  -3560,
  1694,
  "Finalmente, después de idas y venidas hice mi retiro por desempleo, estaré atento a la confirmación.",
  1,
);

node8_7_6.quotes = [
  "“Esperaba el dinero en 5 días y me lo depositaron en 3, sentí que Profuturo llegó como ángel”",
];

const node8_7_6_1 = new TreeNode(
  2,
  false,
  -3560,
  1694,
  "Después de 3 días",
  3 * 24,
);

const node8_7_6_2 = new TreeNode(
  0,
  false,
  -3560,
  1694,
  "Ya me llegó la notificación del depósito, ¡por fin podré estar tranquilo!",
  0,
  "smile",
);

const node8_7_4 = new TreeNode(
  1,
  false,
  -3700,
  1420,
  "Mandamos la solicitud a validar, pero veo que hubo un problema.",
  1,
);

node8_7_4.quotes = [
  "“No me dejaron sacar lo que quería, me dieron un tope de monto, pero al final ese dinero es mío...”",
];

const node8_7_4_1 = new TreeNode(
  0,
  false,
  -3700,
  1420,
  "Dicen que sigo activo ante el IMSS, tienen que pasar 46 días para que me den de baja. ¡Necesito dinero!",
  /*2*/ 0,
);

const node8_7_1_2 = new TreeNode(
  2,
  false,
  -3700,
  1420,
  "46 días después.",
  24 * 46,
);

const node9a = new TreeNode(2, false, -3560, 1694);
const node9b = new TreeNode(2, false, -3560, 1694);
const node9c = new TreeNode(2, false, -3560, 1694);

/**
 * Lista de nodos y sus descendientes
 */

node1.descendants = [
  {
    node: node1_2,
    hint: "Le preguntaré a mis amigos y familiares",
  },
  {
    node: node1_3,
    hint: "Buscaré en internet",
  },
];

node1_2.descendants = [
  {
    node: node4,
    hint: "Lo más seguro es que sí sea Profuturo, buscaré su contacto",
  },
  { node: node2_2, hint: "Buscaré en internet" },
];

node1_3.descendants = [
  {
    node: node4,
    hint: "Lo más seguro es que sí sea Profuturo, buscaré su contacto",
  },
  { node: node2_2, hint: "Buscaré en internet" },
];

node2_2.descendants = [
  {
    node: node4,
    hint: "Continuar",
  },
];

node7_2.descendants = [
  {
    node: node7_2_2,
    hint: "Continuar",
  },
];

node7_2_2.descendants = [
  {
    node: node7_2_2_1,
    hint: "Continuar",
  },
];

node7_2_2_1.descendants = [
  {
    node: node7_2_2_2,
    hint: "Continuar",
  },
];

node7_2_2_2.descendants = [
  {
    node: node7_2_5,
    hint: "Continuar",
  },
];

node7_2_5.descendants = [
  {
    node: node7_2_6,
    hint: "Continuar",
  },
];

node7_2_6.descendants = [
  {
    node: node7_2_6_1,
    hint: "Continuar",
  },
];

node7_2_6_1.descendants = [
  {
    node: node8_4_12,
    hint: "Continuar",
  },
];

node4_1.descendants = [
  {
    node: node4_1_7_dias_despues,
    hint: "Me conviene agendar cita para no esperar en la sucursal",
  },
  {
    node: node7_2,
    hint: "Me urge el dinero, prefiero ir mañana aunque espere mucho tiempo",
  },
];

node4_1_7_dias_despues.descendants = [
  {
    node: node6_2_1,
    hint: "Continuar",
  },
];

node6_2_1.descendants = [
  {
    node: node6_2_1a_1,
    hint: "Continuar",
  },
];

node6_2_1a_1.descendants = [
  {
    node: node8_4_12,
    hint: "Continuar",
  },
];

node8_4_12.descendants = [
  {
    node: node8_4_13,
    hint: "Continuar",
  },
];

node8_4_13.descendants = [
  {
    node: node8_4_14,
    hint: "Compartir",
  },
];

node8_4_14.descendants = [
  {
    node: node8_5,
    hint: "Continuar",
  },
];

node8_5.descendants = [
  {
    node: node8_5_1,
    hint: "Resultado 1",
  },
  //*
  /*{
    node: node8_5_2,
    hint: "Resultado 2",
  },
  {
    node: node8_5_3,
    hint: "Resultado 3",
  },
  {
    node: node8_5_4,
    hint: "Resultado 4",
  },*/
];

node8_5_1.descendants = [
  {
    node: node8_5_1_1,
    hint: "Continuar",
  },
];

node8_5_1_1.descendants = [
  {
    node: node8_5_1_2,
    hint: "Continuar",
  },
];

node8_5_1_2.descendants = [
  {
    node: node8_5_1_3,
    hint: "Continuar",
  },
];

node8_5_1_3.descendants = [
  {
    node: node8_6,
    hint: "Continuar",
  },
];

node8_6.descendants = [
  {
    node: node8_6_1,
    hint: "Continuar",
  },
];

node8_6_1.descendants = [
  {
    node: node8_6_2,
    hint: "Continuar",
  },
];

node8_6_2.descendants = [
  {
    node: node8_5_4,
    hint: "Continuar",
  },
];

node8_5_4.descendants = [
  {
    node: node8_7,
    hint: "Continuar",
  },
];

node8_7.descendants = [
  {
    node: node8_7_4,
    hint: "Resultado 1",
  },
  {
    node: node8_7_5,
    hint: "Resultado 2",
  },
];

node8_7_5.descendants = [
  {
    node: node8_7_5_1,
    hint: "¿Qué sigue?",
  },
];

node8_7_5_1.descendants = [
  {
    node: node8_7_5_2,
    hint: "Continuar",
  },
];

node8_7_5_2.descendants = [
  {
    node: node8_7_6,
    hint: "Continuar",
  },
];

node8_7_6.descendants = [
  {
    node: node8_7_6_1,
    hint: "Continuar",
  },
];

node8_7_6_1.descendants = [
  {
    node: node8_7_6_2,
    hint: "Continuar",
  },
];

node8_7_6_2.descendants = [
  {
    node: node9a,
    hint: "Continuar",
  },
];

node8_7_4.descendants = [
  {
    node: node8_7_4_1,
    hint: "¿Qué pasó?",
  },
];

node8_7_4_1.descendants = [
  {
    node: node8_7_1_2,
    hint: "Continuar",
  },
];

node8_7_1_2.descendants = [
  {
    node: node8_5_4,
    hint: "Continuar",
  },
];

// node8_7

node5_1.descendants = [{ node: node5_1_1, hint: "Continuar" }];

node5_1_1.descendants = [{ node: node5_1_2, hint: "Continuar" }];

node5_1_2.descendants = [{ node: node5_1_3, hint: "Continuar" }];

node5_1_3.descendants = [
  {
    node: node5_aun_no_cliente, // random(() => [node5_cliente_profuturo, node5_aun_no_cliente]),
    // random: [node5_cliente_profuturo, node5_aun_no_cliente], //
    hint: "Proporcionar CURP",
  },
];

node5_aun_no_cliente.descendants = [
  {
    node: node5_aun_no_cliente_1,
    hint: "Continuar",
  },
];

node5_aun_no_cliente_1.descendants = [
  {
    node: node5_aun_no_cliente_1_1,
    hint: "Continuar",
  },
];

node5_aun_no_cliente_1_1.descendants = [
  {
    node: node5_aun_no_cliente_2,
    hint: "Continuar",
  },
];

node5_aun_no_cliente_2.descendants = [
  {
    node: node5_aun_no_cliente_3,
    hint: "Continuar",
  },
];
node5_aun_no_cliente_3.descendants = [
  {
    node: node5_aun_no_cliente_4,
    hint: "Continuar",
  },
];

node5_aun_no_cliente_4.descendants = [
  {
    node: node5_aun_no_cliente_5,
    hint: "Continuar",
  },
];

node5_aun_no_cliente_5.descendants = [
  {
    node: node7,
    hint: "Me conviene agendar una cita para no esperar en la sucursal",
  },
  {
    node: node5_aun_no_cliente_5_1,
    hint: "Me urge el dinero, prefiero ir mañana aunque espere mucho tiempo",
  },
];

node5_aun_no_cliente_5_1.descendants = [
  {
    node: node5_aun_no_cliente_5_2,
    hint: "Continuar",
  },
];

node5_aun_no_cliente_5_2.descendants = [
  {
    node: node5_aun_no_cliente_5_3,
    hint: "Continuar",
  },
];

node5_aun_no_cliente_5_3.descendants = [
  {
    node: node5_aun_no_cliente_5_4_1,
    hint: "Continuar",
  },
];

node5_aun_no_cliente_5_4_1.descendants = [
  {
    node: node5_aun_no_cliente_5_5,
    hint: "Continuar",
  },
];

node5_aun_no_cliente_5_5.descendants = [
  {
    node: node7_2_6,
    hint: "Continuar",
  },
];

node7.descendants = [
  {
    node: node7_1,
    hint: "Continuar",
  },
];

node7_1.descendants = [
  {
    node: node7_1_1,
    hint: "Continuar",
  },
];

node7_1_1.descendants = [
  {
    node: node7_1_2,
    hint: "Continuar",
  },
];

node7_1_2.descendants = [
  {
    node: node7_1_3,
    hint: "Continuar",
  },
];

node7_1_2_a.descendants = [
  {
    node: node7_1_3,
    hint: "Continuar",
  },
];

node7_1_3.descendants = [
  {
    node: node7_1_4,
    hint: "Continuar",
  },
];

node7_1_4.descendants = [
  {
    node: node7_1_5,
    hint: "Continuar",
  },
];

node7_1_5.descendants = [
  {
    node: node7_1_6,
    hint: "Continuar",
  },
];

node7_1_6.descendants = [
  {
    node: node7_1_7,
    hint: "Continuar",
  },
];

node7_1_7.descendants = [
  {
    node: node8,
    hint: "Continuar",
  },
];

node8.descendants = [
  {
    node: node8_2_4_3,
    hint: "Continuar",
  },
];

node8_2_4_3.descendants = [
  {
    node: node8_2_4_4,
    hint: "Continuar",
  },
];

node8_2_4_4.descendants = [
  {
    node: node8_2_4_5,
    hint: "Continuar",
  },
];

node8_2_4_5.descendants = [
  {
    node: node8_2_4_6,
    hint: "Continuar",
  },
];

node8_2_4_6.descendants = [
  {
    node: node8_4,
    hint: "Continuar",
  },
];

node8_4.descendants = [
  {
    node: node8_4_1,
    hint: "Continuar",
  },
];

node8_4_1.descendants = [
  {
    node: node8_4_1_1,
    hint: "Continuar",
  },
];

node8_4_1_1.descendants = [
  {
    node: node8_4_1_2,
    hint: "Continuar",
  },
];

node8_4_1_2.descendants = [
  {
    node: node8_4_12,
    hint: "Continuar",
  },
];

node4.descendants = [
  {
    node: node5_1,
    hint: "Marcaré para que me den toda la información",
  },
  {
    node: node4_1,
    hint: "Visitaré la sucursal más cerca de mi casa para que me apoyen con el trámite",
  },
  {
    node: node_descargar_app,
    hint: "Descargaré la app y veré si por ahí puedo hacer el trámite",
  },
];

node_descargar_app.descendants = [
  { node: node_descargar_app_1, hint: "Continuar" },
];

node_descargar_app_1.descendants = [
  {
    node: random(() => [
      node_descargar_app_1_success,
      node_descargar_app_1_error,
    ]),
    random: [node_descargar_app_1_success, node_descargar_app_1_error],
    hint: "Continuar",
  },
];

node_descargar_app_1_error.descendants = [
  { node: node_descargar_app_1_reintentar, hint: "Continuar" },
];

node_descargar_app_1_reintentar.descendants = [
  { node: node_descargar_app_1_success, hint: "Reintentar" },
];

node_descargar_app_1_success.descendants = [
  { node: node_descargar_app_registrar_expediente, hint: "Continuar" },
];

node_descargar_app_registrar_expediente.descendants = [
  { node: node_descargar_app_expediente_completo, hint: "Continuar" },
];

node_descargar_app_expediente_completo.descendants = [
  {
    node: node_descargar_app_expediente_completo_opcion_retiro,
    hint: "Continuar",
  },
];

node_descargar_app_expediente_completo_opcion_retiro.descendants = [
  {
    node: random(() => [
      node_descargar_app_expediente_completo_acudir_a_sucursal,
      node_descargar_app_expediente_completo_esperar_para_retirar,
      node_descargar_app_expediente_completo_IMSS_no_disponible,
      node_descargar_app_expediente_completo_continuar_proceso,
    ]),
    random: [
      node_descargar_app_expediente_completo_acudir_a_sucursal,
      node_descargar_app_expediente_completo_esperar_para_retirar,
      node_descargar_app_expediente_completo_IMSS_no_disponible,
      node_descargar_app_expediente_completo_continuar_proceso,
    ],
    hint: "Seleccionar",
  },
];

node_descargar_app_expediente_completo_esperar_para_retirar.descendants = [
  {
    node: node_descargar_app_expediente_completo_esperar_para_retirar_1,
    hint: "Continuar",
  },
];

node_descargar_app_expediente_completo_esperar_para_retirar_1.descendants = [
  {
    node: node9c,
    hint: "Continuar",
  },
];

node_descargar_app_expediente_completo_acudir_a_sucursal.descendants = [
  {
    node: node_descargar_app_expediente_completo_acudir_a_sucursal_1,
    hint: "Visitaré la sucursal más cerca de mi casa para que me apoyen con el trámite",
  },
];

node_descargar_app_expediente_completo_acudir_a_sucursal_1.descendants = [
  {
    node: node6_2_1,
    hint: "Continuar",
  },
];

node_descargar_app_expediente_completo_IMSS_no_disponible.descendants = [
  {
    node: node_descargar_app_expediente_completo_IMSS_no_disponible_1,
    hint: "Continuar",
  },
];

node_descargar_app_expediente_completo_IMSS_no_disponible_1.descendants = [
  {
    node: node_descargar_app_expediente_completo_IMSS_no_disponible_2,
    hint: "Continuar",
  },
];

node_descargar_app_expediente_completo_IMSS_no_disponible_2.descendants = [
  {
    node: node_descargar_app_expediente_completo_continuar_proceso,
    hint: "Continuar",
  },
];

node_descargar_app_expediente_completo_continuar_proceso.descendants = [
  {
    node: node_descargar_app_expediente_completo_continuar_proceso_1,
    hint: "Continuar",
  },
];

node_descargar_app_expediente_completo_continuar_proceso_1.descendants = [
  {
    node: node_descargar_app_expediente_completo_continuar_proceso_2,
    hint: "Aceptar implicaciones",
  },
];

node_descargar_app_expediente_completo_continuar_proceso_2.descendants = [
  {
    node: node_descargar_app_expediente_completo_continuar_proceso_3,
    hint: "Continuar",
  },
];

node_descargar_app_expediente_completo_continuar_proceso_3.descendants = [
  {
    node: node_descargar_app_expediente_completo_continuar_proceso_4,
    hint: "Continuar",
  },
];

node_descargar_app_expediente_completo_continuar_proceso_4.descendants = [
  {
    node: node_descargar_app_expediente_completo_continuar_proceso_5,
    hint: "Continuar",
  },
];

node_descargar_app_expediente_completo_continuar_proceso_5.descendants = [
  {
    node: random(() => [
      node_validar_datos_error_actualmente_trabajando,
      node_validar_datos_error_48_dias_transcurridos,
      node_validar_datos_continuar_proceso,
    ]),
    random: [
      node_validar_datos_error_actualmente_trabajando,
      node_validar_datos_error_48_dias_transcurridos,
      node_validar_datos_continuar_proceso,
    ],
    hint: "Continuar",
  },
];

node_validar_datos_error_48_dias_transcurridos.descendants = [
  {
    node: node_validar_datos_error_48_dias_transcurridos_1,
    hint: "Continuar",
  },
];

node_validar_datos_error_48_dias_transcurridos_1.descendants = [
  {
    node: node_validar_datos_error_48_dias_transcurridos_2,
    hint: "Continuar",
  },
];

node_validar_datos_error_48_dias_transcurridos_2.descendants = [
  {
    node: random(() => [
      node_validar_datos_error_actualmente_trabajando,
      node_validar_datos_continuar_proceso,
    ]),
    random: [
      node_validar_datos_error_actualmente_trabajando,
      node_validar_datos_continuar_proceso,
    ],
    hint: "Continuar",
  },
];

node_validar_datos_error_actualmente_trabajando.descendants = [
  {
    node: node_validar_datos_error_actualmente_trabajando_1,
    hint: "Continuar",
  },
];

node_validar_datos_error_actualmente_trabajando_1.descendants = [
  {
    node: node_validar_datos_error_actualmente_trabajando_2,
    hint: "Continuar",
  },
];

node_validar_datos_error_actualmente_trabajando_2.descendants = [
  {
    node: node9a,
    hint: "Continuar",
  },
];

node_validar_datos_continuar_proceso.descendants = [
  {
    node: random(() => [
      node_validar_datos_continuar_proceso_1_1,
      node_validar_datos_continuar_proceso_1_2,
    ]),
    random: [
      node_validar_datos_continuar_proceso_1_1,
      node_validar_datos_continuar_proceso_1_2,
    ],
    hint: "Continuar",
  },
];

node_validar_datos_continuar_proceso_1_1.descendants = [
  {
    node: node_validar_datos_continuar_proceso_2,
    hint: "Continuar",
  },
];

node_validar_datos_continuar_proceso_1_2.descendants = [
  {
    node: node_validar_datos_continuar_proceso_2,
    hint: "Continuar",
  },
];

node_validar_datos_continuar_proceso_2.descendants = [
  { node: node8_7_6, hint: "Continuar" },
];

/** Set last nodes, emotions and endings
 */

node_validar_datos_continuar_proceso_2_end.isLast = true;
node_validar_datos_continuar_proceso_2_end.emotion = "frustrated";
node_validar_datos_continuar_proceso_2_end.ending = 0;

node9a.isLast = true;
node9a.emotion = "smile";
node9a.ending = 0;

node9b.isLast = true;
node9b.emotion = "smile";
node9b.ending = 1;

node9c.isLast = true;
node9c.emotion = "frustrated";
node9c.ending = 2;

/**
 * Export default node1;
 */
export default node1;
